import { useState } from 'react';
import { AddressableViewLayout } from 'framework/ViewTypes';
import { type FilterState } from 'framework/ViewTypes/components';
import { FilterCondition } from 'framework/types';
import { bindCollection } from 'framework/ViewTypes/contentLayout';
import { getApplicationsTableConfig } from './applicationsTableConfig';
import { applicationFilters } from './constants';
import { applicationStatuses } from '../shared/constants';
import { useApplicationsUrl } from '../router';
import useApplicationsListData from './useApplicationsListData';

const ApplicationsPage = () => {
  const collection = useApplicationsListData();
  const [filters, setFilters] = useState<FilterState>({
    status: { [FilterCondition.EQ]: applicationStatuses.ACTIVE },
  });
  const { getSingleEntityUrl } = useApplicationsUrl();

  const binding = bindCollection(
    { ...collection, totalElements: collection.totalRecords },
    getApplicationsTableConfig({ rows: collection.rows, getDetailsUrl: getSingleEntityUrl }),
    {
      searchProps: { disabled: true },
      filterProps: {
        value: filters,
        onChange: setFilters,
        filters: [
          {
            id: 'status',
            source: 'status',
            condition: FilterCondition.EQ,
            type: 'dropdown',
            label: 'Status',
            options: Object.values(applicationStatuses).map(value => ({ value, label: value })),
          },
        ],
        quickFilters: applicationFilters.map(({ id, label }) => ({ id, label, state: {} })),
      },
    },
  );

  return <AddressableViewLayout title="Applications" {...binding.pageProps} />;
};

export default ApplicationsPage;
